import { Component, OnInit } from '@angular/core';
import { MasterService,AttendanceService,AppraisalService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-schoolstragplan',
  templateUrl: './schoolstragplan.component.html',
  styleUrls: ['./schoolstragplan.component.scss'],
   providers:[MasterService,AttendanceService,AppraisalService]
})
export class SchoolstragplanComponent implements OnInit {

   sections:any=[];
             classes:any=[];
             fmodel:any={};
             attdata:any=[];
             arrcourse:any=[];
             arrstaff:any=[];
             oprtype:any='';
             tabledata: any = {};
             strattmarked="";
             showload:any="no";
             showsms:any="no";
             arrteaching:any=[];
             arrobjteaching:any=[];
           
            arrrating=[{id:'Satisfactory',val:'Satisfactory'},{id:'Good',val:'Good'},{id:'Very Good',val:'Very Good'},{id:'Excellent',val:'Excellent'}];
             closeResult: string;
             modalOptions:NgbModalOptions;
             smmodalOptions:NgbModalOptions;
             private modalRef: NgbModalRef;
             private smallmodalRef: NgbModalRef;
           arrquestions: any;
  rid: any='0';
  arranex2: any=[];
  arrobjanex2: any=[];

  arranex3: any=[];
  arrobjanex3: any=[];
             constructor(private http: HttpClient,private apservice:AppraisalService,private aservice:AttendanceService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
           
             ngOnInit(): void {
              this.getquestions(2);
              //  this.getstaff();
               //this.massection();
              //  this.fmodel.attdt=this.mservice.getdatetoday();
             }
           
                setfeedback(j,k,l,m,val)
           {
        debugger
           // alert(j);
           this.arrquestions[j].group2[k].questions[m].aprqtres=val;
           console.log('clicked',this.arrquestions);
        
           }


              addteach()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjteaching.push({rdid:'0',clnm:'' , sunm:'' , strength:'' , avatt:'' , avres:'' , leroutcome:'' });
console.log('arrvoc1',this.arrobjteaching);

}

removetech(index)
{
  
  this.arrobjteaching.splice(index, 1);
         if (this.arrobjteaching.length === 0) {
             this.arrobjteaching = [];
         }

}

 selhrtaprstr_annex1(plnid) {
               this.apservice.selhrtaprstr_annex1(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arrteaching = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }

    savehrtaprstr_annex1(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
   if(oprtype != "d")
   {
        if(this.arrobjteaching.length<1)
        {
alert('Please add atleast one record');
tag=false;
        }
      }
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annex1(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annex1(this.rid);
                this.arrobjteaching=[];
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }
 
   
    addanex2()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanex2.push({rdid:'0',actnm:'' , oucome:'' , yrnm:''  });
console.log('arrvoc1',this.arrobjanex2);

}

remanex2(index)
{
  
  this.arrobjanex2.splice(index, 1);
         if (this.arrobjanex2.length === 0) {
             this.arrobjanex2 = [];
         }

}

printform(residh){
             debugger;
               var clcd=localStorage.getItem('clcd');
               var aycd=localStorage.getItem('aycd');
               var masclid=localStorage.getItem('masclid');
               var usid=localStorage.getItem('usid');
                var url=this.aservice.callurl+"fpdf181/pdfreports/aprstrpln_sc.php?"+clcd+"&aycd="+aycd+"&ayid="+aycd+"&residh="+residh+"&emid="+usid+"&aprfmid=1&masclid="+masclid;
                window.open(url,'','');
              }

 selhrtaprstr_annex2(plnid) {
               this.apservice.selhrtaprstr_annex2(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranex2 = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }

    savehrtaprstr_annex2(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annex2(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annex2(this.rid);
                this.arrobjanex2=[];
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }
 
   
    addanex3()
{
  
  // console.log('arrvoc',this.arrvocdet);
  // this.getacchead1();
this.arrobjanex3.push({rdid:'0',prgnm:'' , conductby:'',duration:'' , yrnm:''  });
console.log('arrvoc1',this.arrobjanex3);

}

remanex3(index)
{
  
  this.arrobjanex3.splice(index, 1);
         if (this.arrobjanex3.length === 0) {
             this.arrobjanex3 = [];
         }

}


 selhrtaprstr_annex3(plnid) {
               this.apservice.selhrtaprstr_annex3(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arranex3 = resultArray;
                      
                       
                   },
                   error => console.log("Error :: " + error)
                   )
             }

    savehrtaprstr_annex3(obj,oprtype)
     {
      debugger;
  //  var feedarr=[];
  obj.oprtype=oprtype;
  obj.rid=this.rid;
   var tag=true;
  
         if(tag)
         { 

       
        //  var pst={aprqtid:this.objhdnvalue.pubaprqtid,residh:this.objhdnvalue.pubresidh,residd:this.objhdnvalue.pubresidd,loopdata:this.arrobjpub};
    
     this.apservice.savehrtaprstr_annex3(obj)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
                this.selhrtaprstr_annex3(this.rid);
                this.arrobjanex3=[];
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }
         
             getstaff() {
               this.mservice.staffrolewise()
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       //resultArray.unshift({emid:"0",emnm:"ALL"});
                    //  resultArray.shift();
                       this.arrstaff = resultArray;
                      
                       this.fmodel.emid=resultArray[0].emid;
                       // this.amodel.emid=resultArray[0].emid;
                       // this.SelectAttdcorDetails();
                      //  this.getquestions(5,1,this.fmodel.emid);
                   },
                   error => console.log("Error :: " + error)
                   )
             }
         
         
              getquestions(plnid) {
               this.apservice.selhrtaprstrpln(plnid)
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       
                       this.arrquestions = resultArray;
                       if(resultArray.length > 0) {
                           this.rid = resultArray[0].rid;
                       }
                   },
                   error => console.log("Error :: " + error)
                   )
             }
         
             
         
           
            
           
             masclass() {
               this.mservice.masclass()
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       this.classes = resultArray;
                       this.fmodel.clid=resultArray[0].clid;
                       //this.fmodel1.clid=resultArray[0].clid;
                       this.massection();
                     //  this.masperiod();
                      // this.mascourse();
                      
                   },
                   error => console.log("Error :: " + error)
                   )
             }
           
            
           
             mascourse() {
               this.mservice.mascourse()
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       this.arrcourse = resultArray;
                       this.fmodel.crid=resultArray[0].crid;
                       this.masclass();
                       //this.fmodel1.crid=resultArray[0].crid;
                   },
                   error => console.log("Error :: " + error)
                   )
             }
           
             // massection() {
             //   this.mservice.massection()
             //       .subscribe(
             //       resultArray => {
             //           console.log('getdashcounts', resultArray);
             //           this.sections = resultArray;
             //           this.fmodel.secid=resultArray[0].scid;
             //       },
             //       error => console.log("Error :: " + error)
             //       )
             // }
           
             massection() {
               this.mservice.massection()
                   .subscribe(
                   resultArray => {
                       console.log('getdashcounts', resultArray);
                       this.sections = resultArray;
                       this.fmodel.secid=resultArray[0].scid;
                      // this.SelectAttdDetails();
                     //  this.getevlrooms();
                       // this.fmodel1.scid=resultArray[0].scid;
                       // this.subjects(this.fmodel.clid,this.fmodel.crid);
                   },
                   error => console.log("Error :: " + error)
                   )
             }
           
             printqrlabelsbulk(obj){
               debugger;
                 var clcd=localStorage.getItem('clcd');
                 var aycd=localStorage.getItem('aycd');
                  var url=this.aservice.callurl+"qrcode/2Upevlstubar.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                  window.open(url,'','_blank');
                }
           
                openqrdl(content)
           {
             // this.objqrprint.bkid=bkid;
             // this.objqrprint.nobc=1;
             this.fmodel.qrdoctype='2Upevlstubar';
           
           
             this.modalRef=this.modalService.open(content,this.smmodalOptions);
             
             this.modalRef.result.then((result) => {
            
                  // this.Asmtdetls(asid);
                   this.closeResult = `Closed with: ${result}`;
               }, (reason) => {
                   // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
               });
           }
           
                printqrlabels(obj){
                 debugger;
                   var clcd=localStorage.getItem('clcd');
                   var aycd=localStorage.getItem('aycd');
                    var url=this.aservice.callurl+"qrcode/"+obj.qrdoctype+".php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                    window.open(url,'','');
                  }
             
                expbarlist(obj){
                 debugger;
                   var clcd=localStorage.getItem('clcd');
                   var aycd=localStorage.getItem('aycd');
                    var url=this.aservice.callurl+"export/expcsv_roomallot.php?clcd="+clcd+"&aycd="+aycd+"&clid="+obj.clid+"&scid="+obj.secid+"&crid="+obj.crid+"&rmid="+obj.rmid;
                    window.open(url,'');
                  }
               
             SelectAttdDetails() {
               debugger
               var clid = this.fmodel.clid;
               var crid = this.fmodel.crid;
               var secid = this.fmodel.secid;
               var rmid = this.fmodel.rmid;
               let clcd=localStorage.getItem('clcd');
               let aycd=localStorage.getItem('aycd');
               
               var asgnmtdata = { clid: clid, clcd:clcd,aycd:aycd,crid:crid,rmid:rmid };
               console.log('model-by', asgnmtdata);
               this.aservice.getroomallocationdata(asgnmtdata)
                   .subscribe(resultArray => {
                       console.log('ret-by-atd', resultArray);
           //alert(resultArray.length);
                    
                      resultArray.forEach(x => x.status = x.status === 'true');
                      this.attdata=resultArray;
                   }, error =>
                       alert('error in connection')
                   );
           }
           
           // Savedetails()
           // {
           
           //   console.log('savearr',this.attdata);
           // }
           
           
           
           SelectAttdDtlsifnotavail() {
               debugger
               var clid = this.fmodel.clid;
               var crid = this.fmodel.crid;
               var secid = this.fmodel.secid;
               var attdt = this.fmodel.attdt;
               let clcd=localStorage.getItem('clcd');
               let aycd=localStorage.getItem('aycd');
               
               var asgnmtdata = { clid: clid, secid: secid, attdt: attdt,oprtype:'selstuses',clcd:clcd,aycd:aycd,crid:crid};
               console.log('model-by', asgnmtdata);
               this.aservice.by_sp_clmattendance(asgnmtdata)
                   .subscribe(resultArray => {
                       console.log('ret-by-atd', resultArray);
                       this.attdata = resultArray;
           
                       //alert(resultArray.message);
           
                   }, error =>
                       alert('error in connection')
                   );
           }
           
           
        //    saveappraisal()
        //    {
        //     debugger
        //  var feedarr=[];
        //  var tag=true
        //      outerloop:for(let j=0;j<this.arrquestions.length;j++)
        //        {
         
        //          for (let k=0;k<this.arrquestions[j].group2.length;k++)
        //          {
        //           //  for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
        //           //  {
        //          for(let i=0;i<this.arrquestions[j].group2[k].questions.length;i++)
        //          {
        //          let objitm:any={};
        //          if(this.arrquestions[j].group2[k].questions[i].aprqtres.trim() == "")
        //          {
        //            alert('Please fill all the details');
        //            tag=false;
        //            break outerloop;
        //          }
        //            objitm.aprqtid=this.arrquestions[j].group2[k].questions[i].aprqtid;
        //          objitm.residh=this.arrquestions[j].group2[k].questions[i].residh;
        //          objitm.residd=this.arrquestions[j].group2[k].questions[i].residd;
        //          objitm.aprqtres=this.arrquestions[j].group2[k].questions[i].aprqtres.trim();
        //          objitm.aprqtrmk1=this.arrquestions[j].group2[k].questions[i].aprqtrmk1.trim();
        //          objitm.aprqtrmk2=this.arrquestions[j].group2[k].questions[i].aprqtrmk2.trim();
        //          console.log('objitm',objitm);
        //          feedarr.push(objitm);
                 
        //          }
        //       //  }
        //        }
        //        }
         
        //        if(tag)
        //        { 
        //        var pst={step:1,emid:"",loopdata:feedarr};
          
        //    this.apservice.saveappraisal(pst)
        //          .subscribe(
        //          result => {
        //              console.log('SavegenmasDetails', result);
        //              //this.suppliers = resultArray;
        //              alert(result.message);
        //              if(result.status=='success')
        //              {
                       
        //              this.SelectAttdDetails();
        //              }
        //             else
        //             {
           
        //             }
        //          },
        //          error =>{ alert('Error While saving...');}
        //          )
           
        //    console.log('data',feedarr);
        //    }
        //  }

        saveappraisalsem()
     {
   var feedarr=[];
   var tag=true;

     outerloop:for(let j=0;j<this.arrquestions.length;j++)
               {
         
                 for (let k=0;k<this.arrquestions[j].group2.length;k++)
                 {
                  //  for(let l=0;l<this.arrquestions[j].group2[k].group3.length;l++)
                  //  {
                 for(let i=0;i<this.arrquestions[j].group2[k].questions.length;i++)
                 {
                 let objitm:any={};
                 
                   objitm.rdid=this.arrquestions[j].group2[k].questions[i].rdid;
                 objitm.pryr1=this.arrquestions[j].group2[k].questions[i].pryr1.trim();
                 objitm.pryr2=this.arrquestions[j].group2[k].questions[i].pryr2.trim();
                 objitm.cryr1=this.arrquestions[j].group2[k].questions[i].cryr1.trim();
                 objitm.cryr2=this.arrquestions[j].group2[k].questions[i].cryr2.trim();
                    objitm.cryr3=this.arrquestions[j].group2[k].questions[i].cryr3.trim();
                 console.log('objitm',objitm);
                 feedarr.push(objitm);
                 
                 }
              //  }
               }
               }
       
         if(tag)
         { 

        
         var pst={loopdata:feedarr};
    
     this.apservice.savehrstgyplan(pst)
           .subscribe(
           result => {
               console.log('SavegenmasDetails', result);
               //this.suppliers = resultArray;
               alert(result.message);
               if(result.status=='success')
               {
               this.getquestions(2);
               }
              else
              {
     
              }
           },
           error =>{ alert('Error While saving...');}
           )
     
     
     }
   }
           }
           
         
      
    
  
